import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";

export default function Events() {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState<Record<number, boolean>>({});

  useEffect(() => {
    // Scroll to the top when the route changes
    window.scrollTo(0, 0);
  }, []);

  const events = [
    { id: 1, image: "/assets/item_1_1.jpeg" },
    { id: 2, image: "/assets/wahjMart_1.png" },
    { id: 3, image: "/assets/jenan_01.png" },
    { id: 4, image: "/assets/item_2_1.jpeg" },
    { id: 5, image: "/assets/item_3_3.png" },
    { id: 6, image: "/assets/item_5_2.png" },
  ];

  const handleChange = (data: string) => {
    navigate(`/events/${data}`);
  };

  const handleImageLoad = (id: number) => {
    setImageLoaded(prev => ({ ...prev, [id]: true }));
  };

  return (
    <>
      <div className="p-4 bg-white py-14 relative">
        {/* absolute portion */}
        <div className='absolute w-52 h-52 bg-[#bb8624] z-30 rounded-full blur-[100px]'></div>
        <div className='absolute w-52 h-52 right-10 bottom-0 z-30 bg-[#bb8624] rounded-full blur-[100px]'></div>
        <div className='absolute w-52 h-52 right-[50%] top-[40%] z-30 bg-[#bb8624] rounded-full blur-[100px]'></div>
        <div className='absolute w-52 h-52 right-0 top-10 z-30 bg-[#bb8624] rounded-full blur-[100px]'></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7 mt-8 md:px-10 py-5 z-20">
          {events.map((event) => (
            <div
              key={event.id}
              onClick={() => handleChange(event.id.toString())}
              className="bg-white hover:scale-[0.98] hover:shadow-xl z-40 cursor-pointer transition-all duration-300 ease-in-out shadow-lg rounded-lg overflow-hidden border border-gray-200"
            >
              <div className="relative w-full h-52">
                {!imageLoaded[event.id] && (
                  <div className="absolute inset-0 animate-pulse bg-gray-200">
                    <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[pulse_1.5s_ease-in-out_infinite]"></div>
                  </div>
                )}
                <img
                  src={event.image}
                  alt={`Event ${event.id}`}
                  className={`w-full h-52 object-cover transition-opacity duration-500 ease-in-out ${
                    imageLoaded[event.id] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                  }`}
                  onLoad={() => handleImageLoad(event.id)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}